import React from 'react'

import { useHistory } from 'react-router-dom'

import Icon from '../icon'

import * as S from './styles'

import IProps from './props'

import userIMG from '../../assets/png/user-profile.png'

import { getRoute, LinkBuilder } from '../../helpers'
import { RoutesEnum, Authority } from '../../enums'

const ContractorCard = ({
  imgUrl,
  name,
  city,
  availability,
  // specialty,
  showIcon,
  hasNewMessage,
  chatId,
}: IProps) => {
  const history = useHistory()

  const handleClick = () => {
    history.push(RoutesEnum.CHAT, {
      interlocutorType: Authority.CONTRACTOR,
      interlocutorId: String(chatId),
    })
  }

  const handleGoToProfile = () => {
    history.push(getRoute(RoutesEnum.CONTRACTOR_DOCTOR, { id: String(chatId) }))
  }

  return (
    <div style={{ position: 'relative' }}>
      {showIcon && (
        <Icon
          name="message"
          data-name="message"
          onClick={handleClick}
          style={{
            position: 'absolute',
            top: '10px',
            right: '12px',
            zIndex: '999',
            cursor: 'pointer',
          }}
        />
      )}
      <S.Container onClick={handleGoToProfile}>
        {hasNewMessage && <S.Circle />}
        <S.Image src={imgUrl ? LinkBuilder.buildAssetsUrl(imgUrl) : userIMG} />
        <S.ContractorInfo>
          <S.ContractorTitle>{name}</S.ContractorTitle>
          <S.ContractorDescription>
            <Icon name="map" />
            <S.DescriptionTitle>Local: </S.DescriptionTitle>
            <S.DescriptionValue>{city}</S.DescriptionValue>
          </S.ContractorDescription>
          <S.ContractorDescription>
            <Icon name="clock" />
            <S.DescriptionTitle>Disponibilidade: </S.DescriptionTitle>
            <S.DescriptionValue>{availability}</S.DescriptionValue>
          </S.ContractorDescription>
        </S.ContractorInfo>
      </S.Container>
    </div>
  )
}

ContractorCard.defaultProps = {
  showIcon: true,
  hasNewMessage: false,
}

export default ContractorCard
